import React from 'react';
import { TextField } from '@mui/material';

const ClientName = ({clientName, handleClientNameChange}) => {
    return (
        <TextField
            label="Client Name"
            name="clientName"
            value={clientName}
            onChange = {(e) => handleClientNameChange(e.target.value)}
            fullWidth
            multiline
            required
        />
    );
};

export default ClientName;
